<script setup lang="ts">
import { computed } from 'vue';

import type { VRouterTab } from '@components/tabs/VRouterTabs/types';
import VCard from '@components/card/VCard/VCard.vue';
import VRouterTabs from '@components/tabs/VRouterTabs/VRouterTabs.vue';
import { useI18n } from '@modules/i18n/composables';
import { usePermissionsStore } from '@modules/permissions/store';

import { AFFILIATES_APPROVED_PROFILE_PERMISSIONS, TRANSLATION_GROUP_AFFILIATE_PROFILE } from '../../constants';
import { AFFILIATE_PROFILE_CONTACTS_ROUTE_NAME, TRANSLATION_GROUP_AFFILIATE_PROFILE_CONTACTS } from '../../submodules/contacts/constants';
import { AFFILIATE_PROFILE_GENERAL_ROUTE_NAME, TRANSLATION_GROUP_AFFILIATE_PROFILE_GENERAL } from '../../submodules/general/constants';
import { AFFILIATE_PROFILE_SUBAFFILIATE_ROUTE_NAME, TRANSLATION_GROUP_AFFILIATE_PROFILE_SUBAFFILIATE } from '../../submodules/subaffiliate/constants';

const { getTranslation } = useI18n();
const { hasPermission } = usePermissionsStore();

const tabs = computed<VRouterTab[]>(() => [
  {
    label: getTranslation(TRANSLATION_GROUP_AFFILIATE_PROFILE_GENERAL, 'TAB_NAME').value,
    route: {
      name: AFFILIATE_PROFILE_GENERAL_ROUTE_NAME,
    },
  },
  {
    label: getTranslation(TRANSLATION_GROUP_AFFILIATE_PROFILE_CONTACTS, 'TAB_NAME').value,
    route: {
      name: AFFILIATE_PROFILE_CONTACTS_ROUTE_NAME,
    },
  },
  {
    label: getTranslation(TRANSLATION_GROUP_AFFILIATE_PROFILE_SUBAFFILIATE, 'TAB_NAME').value,
    route: {
      name: AFFILIATE_PROFILE_SUBAFFILIATE_ROUTE_NAME,
    },
    visible: hasPermission(AFFILIATES_APPROVED_PROFILE_PERMISSIONS.INVITATIONS_EDIT).value,
  },
]);
</script>

<template>
  <VCard v-data-qa-auto-id="'AffiliateProfilePage'"
    type="form"
    :title="$getTranslation(TRANSLATION_GROUP_AFFILIATE_PROFILE, 'SETTINGS_HEADER')"
  >
    <VRouterTabs
      :items="tabs"
      class="mb-10"
      replace
    />
    <RouterView />
  </VCard>
</template>
